<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row" v-if="site_type == 'ho'">
                        <div class="col-md-4">
                            <base-input label="Location">
                                <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isExtended">
                        Extended Option
                    </base-checkbox>

                    <div v-if="subBrandOptions.length > 0" class="row">
                        <div class="col-md-4">
                            <base-input label="Sub Brand">
                                <a-select v-model="inputSubBrands" placeholder="Select Sub Brand" size="large" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" mode="multiple" showSearch >
                                    <a-select-option
                                    v-for="sub_brand_option in subBrandOptions"
                                    :key="sub_brand_option.id.toString()"
                                    :value="sub_brand_option.id.toString()"
                                    >{{ sub_brand_option.name }}
                                    </a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select v-if="isExtended == true" class="form-control" size="large" v-model="inputGroupExtendedBy" @click.prevent="autoChange">
                                    <option v-for="option in groupExtendedOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>

                                <select v-else class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">>
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-checkbox class="mb-3" v-model="isNetReturn" :disabled="isVatBreakdown == true">
                                Net of Returns Sales
                            </base-checkbox>
                        </div>
                        <div class="col-md-4">
                            <base-checkbox class="mb-3" v-model="isPercent" :disabled="isVatBreakdown == true">
                                Show Percent Sales
                            </base-checkbox>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-checkbox class="mb-3" v-model="isDiscount" :disabled="isVatBreakdown == true">
                                Show Discount
                            </base-checkbox>
                        </div>
                        <div class="col-md-4">
                            <base-checkbox class="mb-3" v-model="isVatBreakdown">
                                Show VAT Breakdown
                            </base-checkbox>
                        </div>
                    </div>

                    <div class="row" v-if="site_type == 'ho'">
                        <div class="col-md-4">
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate per site
                            </base-checkbox>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{toggleLabel}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import VueJsonToCsv from 'vue-json-to-csv';
    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'division_id',
                inputGroupExtendedBy: 'division_id, department_id',
                groupOptions: [
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'}
                ],
                groupExtendedOptions: [
                    {key: 'division_id, department_id', value: 'Division, Department'},
                    {key: 'division_id, section_id', value: 'Division, Section'},
                    {key: 'department_id, section_id', value: 'Department, Section'},
                    {key: 'section_id', value: 'Section'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'grouper_id',
                sortOptions: [
                    {key: 'grouper_id', value: 'Division'},
                    {key: 'total_amount', value: 'Total Amount'},
                    {key: 'qty', value: 'Total Quantity'}
                ],
                isExtended: false,
                isVatBreakdown: false,
                isPercent: false,
                isDiscount: false,
                isNetReturn: false,
                birSalesReports: [],

                inputLocation: [],
                locationOptions: [],
                isSeparateSite: true,

                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                JsonData: [],
                inputBrand: null,
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            component_x.getBrandOptions();
        },
        computed: {
            ...mapState(['currentProfile','endPoint', 'categoriesOptions']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        watch: {
            isExtended: function() {
                let groupByValue = this.inputGroupBy;
                if(this.isExtended == true){
                    groupByValue = this.inputGroupExtendedBy;
                }
                let e = {
                    target: {
                        value: groupByValue
                    }
                }
                this.autoChange(e)
            },
            isVatBreakdown: function() {
                if(this.isVatBreakdown == true){
                    this.isPercent = true
                    this.isNetReturn = false
                    this.isDiscount = false
                }
            }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == 'department_id' || e.target.value == 'department_id, section_id'){
                    this.sortOptions[0].value = 'Department'
                } else if(e.target.value == 'section_id'){
                    this.sortOptions[0].value = 'Section'
                } else if(e.target.value == 'category_id'){
                    this.sortOptions[0].value = 'Category'
                } else {
                    this.sortOptions[0].value = 'Division'
                }
            },
            showFixed(num, fixed) {
                fixed = fixed || 0;
                fixed = Math.pow(10, fixed);
                return Math.floor(num * fixed) / fixed;
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            generateReport: async function () {
                this.spinning = true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let selectedGroup = this.inputGroupBy
                if(this.isExtended == true){
                    selectedGroup = this.inputGroupExtendedBy
                }

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "is_extended": this.isExtended,
                    "is_discount": this.isDiscount,
                    "is_percent": this.isPercent,
                    "is_return": this.isNetReturn,
                    "is_vat": this.isVatBreakdown,
                    "group": selectedGroup,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'category_sales?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                
                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];

                    let header_detail = [];
                    let header_top = [
                        {content: this.sortOptions[0].value, rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Sales', colSpan: 2, styles: {halign: 'center', valign: 'center'}}
                    ];

                    header_detail.push(
                        {content: 'Total Qty', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                    )

                    if(this.isNetReturn == true){
                        header_top.push({content: 'Returns', colSpan: 2, styles: {halign: 'center', valign: 'center'}})
                        header_top.push({content: 'Net of Returns', colSpan: 2, styles: {halign: 'center', valign: 'center'}})

                        header_detail.push(
                            {content: 'Total Qty', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Total Qty', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                        )
                    }

                    if(this.isDiscount == true){
                        header_top.push({content: 'Discount', rowSpan: 2, styles: {halign: 'center', valign: 'center'}})
                    }

                    if(this.isVatBreakdown == true){
                        header_top.push({content: 'VATable', rowSpan: 2, styles: {halign: 'center', valign: 'center'}})
                        header_top.push({content: 'VAT', rowSpan: 2, styles: {halign: 'center', valign: 'center'}})
                        header_top.push({content: 'Non-VATable', rowSpan: 2, styles: {halign: 'center', valign: 'center'}})
                        header_top.push({content: 'Add-on', rowSpan: 2, styles: {halign: 'center', valign: 'center'}})
                    }

                    if(this.isPercent == true){
                        header_top.push({content: '% Share', rowSpan: 2, styles: {halign: 'center', valign: 'center'}})
                    }

                    headers = [header_top, header_detail]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let tmp_total_amount = 0
                            let tmp_total_percent = 0

                            if(this.isPercent == true){
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    tmp_total_amount += Number(reportLine.total_amount)
                                }

                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    let percent = (Number(reportLine.total_amount) / tmp_total_amount) * 100
                                    tmp_total_percent += Number(percent.toFixed(2))
                                }
                            }
                            let excess_percent = tmp_total_percent - 100

                            let total_qty = 0
                            let total_total_amount = 0
                            let total_discount = 0
                            let total_percent = 0

                            let grand_qty = 0
                            let grand_total_amount = 0
                            let grand_discount = 0

                            let sub_percent = 100

                            let total_return_qty = 0
                            let total_return_total_amount = 0

                            let grand_return_qty = 0
                            let grand_return_total_amount = 0

                            let total_vatable = 0
                            let total_vat = 0
                            let total_non_vat = 0
                            let total_add_on = 0
                            let grand_vatable = 0
                            let grand_vat = 0
                            let grand_non_vat = 0
                            let grand_add_on = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(selectedGroup != 'category_id'){
                                    if(grouper == 'start'){
                                        let detail_header = [{content: grouper_name, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.grouper_id){
                                            let detail_header = [{content: grouper_name, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.grouper_id
                                }

                                let detail = []
                                detail = [
                                    reportLine.detail_name,
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    this.convertToCurrency(Number(reportLine.total_amount))
                                ]

                                if(this.isNetReturn == true){
                                    detail.push(this.convertToCurrency(Number(reportLine.return_qty)))
                                    detail.push(this.convertToCurrency(Number(reportLine.return_total_amount)))

                                    //net of returns
                                    let net_qty = Number(reportLine.qty) - Number(reportLine.return_qty)
                                    let net_total_amount = Number(reportLine.total_amount) - Number(reportLine.return_total_amount)

                                    detail.push(this.convertToCurrency(net_qty))
                                    detail.push(this.convertToCurrency(net_total_amount))
                                }

                                if(this.isDiscount == true){
                                    detail.push(this.convertToCurrency(Number(reportLine.discount)))
                                }

                                if(this.isVatBreakdown == true){
                                    //detail.push(this.convertToCurrency(Number(reportLine.vatable)))
                                    detail.push(this.convertToCurrency(Number(reportLine.total_amount - reportLine.vat)))
                                    detail.push(this.convertToCurrency(Number(reportLine.vat)))
                                    detail.push(this.convertToCurrency(Number(reportLine.non_vat)))
                                    detail.push(this.convertToCurrency(Number(reportLine.add_on)))
                                }

                                if(this.isPercent == true){
                                    let percent = (Number(reportLine.total_amount) / tmp_total_amount) * 100
                                    let converted = this.showFixed(percent, 2)
                                    let fixed = Number(percent.toFixed(2))
                                    let decided = fixed
                                    if(excess_percent != 0){
                                        if(excess_percent > 0){
                                            if(percent != fixed){
                                                decided = converted
                                                excess_percent -= 0.01
                                            }
                                        }
                                    }
                                    detail.push(this.convertToCurrency(decided))
                                    total_percent += decided
                                }

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)

                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)

                                if(this.isDiscount == true){
                                    total_discount += Number(reportLine.discount)
                                    grand_discount += Number(reportLine.discount)
                                }

                                if(this.isNetReturn == true){
                                    total_return_qty += Number(reportLine.return_qty)
                                    total_return_total_amount += Number(reportLine.return_total_amount)

                                    grand_return_qty += Number(reportLine.return_qty)
                                    grand_return_total_amount += Number(reportLine.return_total_amount)
                                }

                                if(this.isVatBreakdown == true){
                                    total_vatable += Number(reportLine.total_amount - reportLine.vat)
                                    total_vat += Number(reportLine.vat)
                                    total_non_vat += Number(reportLine.non_vat)
                                    total_add_on += Number(reportLine.add_on)

                                    grand_vatable += Number(reportLine.total_amount - reportLine.vat)
                                    grand_vat += Number(reportLine.vat)
                                    grand_non_vat += Number(reportLine.non_vat)
                                    grand_add_on += Number(reportLine.add_on)
                                }

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    if(selectedGroup != 'category_id'){
                                        sub_detail = ['Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_total_amount)
                                        ]

                                        if(this.isNetReturn == true){
                                            sub_detail.push(this.convertToCurrency(total_return_qty))
                                            sub_detail.push(this.convertToCurrency(total_return_total_amount))

                                            //net of returns
                                            let net_qty = total_qty - total_return_qty
                                            let net_total_amount = total_total_amount - total_return_total_amount

                                            sub_detail.push(this.convertToCurrency(net_qty))
                                            sub_detail.push(this.convertToCurrency(net_total_amount))
                                        }

                                        if(this.isDiscount == true){
                                            sub_detail.push(this.convertToCurrency(total_discount))
                                        }

                                        if(this.isVatBreakdown == true){
                                            sub_detail.push(this.convertToCurrency(total_vatable))
                                            sub_detail.push(this.convertToCurrency(total_vat))
                                            sub_detail.push(this.convertToCurrency(total_non_vat))
                                            sub_detail.push(this.convertToCurrency(total_add_on))
                                        }

                                        if(this.isPercent == true){
                                            sub_detail.push(this.convertToCurrency(sub_percent))
                                        }
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
                                    }

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    let grand_detail = ['Grand Total :',
                                        this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_total_amount)
                                    ]

                                    if(this.isNetReturn == true){
                                        grand_detail.push(this.convertToCurrency(grand_return_qty))
                                        grand_detail.push(this.convertToCurrency(grand_return_total_amount))

                                        //net of returns
                                        let net_qty = grand_qty - grand_return_qty
                                        let net_total_amount = grand_total_amount - grand_return_total_amount

                                        grand_detail.push(this.convertToCurrency(net_qty))
                                        grand_detail.push(this.convertToCurrency(net_total_amount))
                                    }

                                    if(this.isDiscount == true){
                                        grand_detail.push(this.convertToCurrency(grand_discount))
                                    }

                                    if(this.isVatBreakdown == true){
                                        grand_detail.push(this.convertToCurrency(grand_vatable))
                                        grand_detail.push(this.convertToCurrency(grand_vat))
                                        grand_detail.push(this.convertToCurrency(grand_non_vat))
                                        grand_detail.push(this.convertToCurrency(grand_add_on))
                                    }

                                    if(this.isPercent == true){
                                        grand_detail.push(this.convertToCurrency(100))
                                    }
                                    reportData.push(Object.assign({}, grand_detail));

                                } else {
                                    if(selectedGroup != 'category_id'){
                                        let current_grouper = ""
                                        let next_grouper = ""

                                        current_grouper = reportLine.grouper_id
                                        next_grouper = this.birSalesReports[i+1].grouper_id

                                        if(current_grouper != next_grouper){
                                            sub_detail = ['Sub Total :',
                                                this.convertToCurrency(total_qty),
                                                this.convertToCurrency(total_total_amount)
                                            ]

                                            if(this.isNetReturn == true){
                                                sub_detail.push(this.convertToCurrency(total_return_qty))
                                                sub_detail.push(this.convertToCurrency(total_return_total_amount))

                                                //net of returns
                                                let net_qty = total_qty - total_return_qty
                                                let net_total_amount = total_total_amount - total_return_total_amount

                                                sub_detail.push(this.convertToCurrency(net_qty))
                                                sub_detail.push(this.convertToCurrency(net_total_amount))
                                            }

                                            if(this.isDiscount == true){
                                                sub_detail.push(this.convertToCurrency(total_discount))
                                            }

                                            if(this.isVatBreakdown == true){
                                                sub_detail.push(this.convertToCurrency(total_vatable))
                                                sub_detail.push(this.convertToCurrency(total_vat))
                                                sub_detail.push(this.convertToCurrency(total_non_vat))
                                                sub_detail.push(this.convertToCurrency(total_add_on))
                                            }

                                            if(this.isPercent == true){
                                                if(total_percent == 0 && total_total_amount > 0 && sub_percent == 100){
                                                    sub_percent -= 0.01
                                                } else {
                                                    sub_percent -= total_percent
                                                }
                                                sub_detail.push(this.convertToCurrency(total_percent))
                                            }

                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))

                                            total_qty = 0
                                            total_total_amount = 0
                                            total_discount = 0
                                            total_percent = 0

                                            total_return_qty = 0
                                            total_return_total_amount = 0

                                            total_vatable = 0
                                            total_vat = 0
                                            total_non_vat = 0
                                            total_add_on = 0
                                        }
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Category Sales Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(340,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 90},
                            1: {cellWidth: 30},
                            2: {cellWidth: 30},
                            3: {cellWidth: 30},
                            4: {cellWidth: 30},
                            5: {cellWidth: 30},
                            6: {cellWidth: 30},
                            7: {cellWidth: 30},
                            8: {cellWidth: 30}
                        }

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: {bottom: 30},
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                        if(this.isPercent == true){
                            var finalY = doc.lastAutoTable.finalY;
                            var legends = ['% Share = Amount / Grand Total * 100%']
                            reportUtils.pdfTools.addLegend(doc, legends, finalY)
                        }
                    }
                    let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }


                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Category Sales Report" + group_text, 340, 200, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Category_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            generateFile: async function() {
                this.spinning = true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let selectedGroup = this.inputGroupBy
                if(this.isExtended == true){
                    selectedGroup = this.inputGroupExtendedBy
                }

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "is_extended": this.isExtended,
                    "is_discount": this.isDiscount,
                    "is_percent": this.isPercent,
                    "is_return": this.isNetReturn,
                    "is_vat": this.isVatBreakdown,
                    "group": selectedGroup,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'category_sales?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_top = [this.sortOptions[0].value];

                    header_top.push('Sales Total Qty',' Sales Total Amount')

                    if(this.isNetReturn == true){
                        header_top.push('Returns','Net of Returns')

                        header_top.push('Total Qty','Total Amount','Total Qty','Total Amount')
                    }

                    if(this.isDiscount == true){
                        header_top.push('Discount')
                    }

                    if(this.isVatBreakdown == true){
                        header_top.push('VATable','VAT', 'Non-VATable','Add-on')
                    }

                    if(this.isPercent == true){
                        header_top.push('% Share')
                    }

                    headers = header_top

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push([])
                            reportData.push(["Division", "Sales Total Qty", "Sales Total Amount"])
                        }

                        if(this.birSalesReports.length > 0){
                            let tmp_total_amount = 0
                            let tmp_total_percent = 0

                            if(this.isPercent == true){
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    tmp_total_amount += Number(reportLine.total_amount)
                                }

                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    let percent = (Number(reportLine.total_amount) / tmp_total_amount) * 100
                                    tmp_total_percent += Number(percent.toFixed(2))
                                }
                            }
                            let excess_percent = tmp_total_percent - 100

                            let total_qty = 0
                            let total_total_amount = 0
                            let total_discount = 0
                            let total_percent = 0

                            let grand_qty = 0
                            let grand_total_amount = 0
                            let grand_discount = 0

                            let sub_percent = 100

                            let total_return_qty = 0
                            let total_return_total_amount = 0

                            let grand_return_qty = 0
                            let grand_return_total_amount = 0

                            let total_vatable = 0
                            let total_vat = 0
                            let total_non_vat = 0
                            let total_add_on = 0
                            let grand_vatable = 0
                            let grand_vat = 0
                            let grand_non_vat = 0
                            let grand_add_on = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(selectedGroup != 'category_id'){
                                    if(grouper == 'start'){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.grouper_id){
                                            let detail_header = [grouper_name];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.grouper_id
                                }

                                let detail = []
                                detail = [
                                    reportLine.detail_name,
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    this.convertToCurrency(Number(reportLine.total_amount))
                                ]

                                if(this.isNetReturn == true){
                                    detail.push(this.convertToCurrency(Number(reportLine.return_qty)))
                                    detail.push(this.convertToCurrency(Number(reportLine.return_total_amount)))

                                    //net of returns
                                    let net_qty = Number(reportLine.qty) - Number(reportLine.return_qty)
                                    let net_total_amount = Number(reportLine.total_amount) - Number(reportLine.return_total_amount)

                                    detail.push(this.convertToCurrency(net_qty))
                                    detail.push(this.convertToCurrency(net_total_amount))
                                }

                                if(this.isDiscount == true){
                                    detail.push(this.convertToCurrency(Number(reportLine.discount)))
                                }

                                if(this.isVatBreakdown == true){
                                    detail.push(this.convertToCurrency(Number(reportLine.total_amount - reportLine.vat)))
                                    detail.push(this.convertToCurrency(Number(reportLine.vat)))
                                    detail.push(this.convertToCurrency(Number(reportLine.non_vat)))
                                    detail.push(this.convertToCurrency(Number(reportLine.add_on)))
                                }

                                if(this.isPercent == true){
                                    let percent = (Number(reportLine.total_amount) / tmp_total_amount) * 100
                                    let converted = this.showFixed(percent, 2)
                                    let fixed = Number(percent.toFixed(2))
                                    let decided = fixed
                                    if(excess_percent != 0){
                                        if(excess_percent > 0){
                                            if(percent != fixed){
                                                decided = converted
                                                excess_percent -= 0.01
                                            }
                                        }
                                    }
                                    detail.push(this.convertToCurrency(decided))
                                    total_percent += decided
                                }

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)

                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)

                                if(this.isDiscount == true){
                                    total_discount += Number(reportLine.discount)
                                    grand_discount += Number(reportLine.discount)
                                }

                                if(this.isNetReturn == true){
                                    total_return_qty += Number(reportLine.return_qty)
                                    total_return_total_amount += Number(reportLine.return_total_amount)

                                    grand_return_qty += Number(reportLine.return_qty)
                                    grand_return_total_amount += Number(reportLine.return_total_amount)
                                }

                                if(this.isVatBreakdown == true){
                                    total_vatable += Number(reportLine.total_amount - reportLine.vat)
                                    total_vat += Number(reportLine.vat)
                                    total_non_vat += Number(reportLine.non_vat)
                                    total_add_on += Number(reportLine.add_on)

                                    grand_vatable += Number(reportLine.total_amount - reportLine.vat)
                                    grand_vat += Number(reportLine.vat)
                                    grand_non_vat += Number(reportLine.non_vat)
                                    grand_add_on += Number(reportLine.add_on)
                                }

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    if(selectedGroup != 'category_id'){
                                        sub_detail = ['Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_total_amount)
                                        ]

                                        if(this.isNetReturn == true){
                                            sub_detail.push(this.convertToCurrency(total_return_qty))
                                            sub_detail.push(this.convertToCurrency(total_return_total_amount))

                                            //net of returns
                                            let net_qty = total_qty - total_return_qty
                                            let net_total_amount = total_total_amount - total_return_total_amount

                                            sub_detail.push(this.convertToCurrency(net_qty))
                                            sub_detail.push(this.convertToCurrency(net_total_amount))
                                        }

                                        if(this.isDiscount == true){
                                            sub_detail.push(this.convertToCurrency(total_discount))
                                        }

                                        if(this.isVatBreakdown == true){
                                            sub_detail.push(this.convertToCurrency(total_vatable))
                                            sub_detail.push(this.convertToCurrency(total_vat))
                                            sub_detail.push(this.convertToCurrency(total_non_vat))
                                            sub_detail.push(this.convertToCurrency(total_add_on))
                                        }

                                        if(this.isPercent == true){
                                            sub_detail.push(this.convertToCurrency(sub_percent))
                                        }
                                        reportData.push(Object.assign({}, sub_detail))
                                    }


                                    let grand_detail = ['Grand Total :',
                                        this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_total_amount)
                                    ]

                                    if(this.isNetReturn == true){
                                        grand_detail.push(this.convertToCurrency(grand_return_qty))
                                        grand_detail.push(this.convertToCurrency(grand_return_total_amount))

                                        //net of returns
                                        let net_qty = grand_qty - grand_return_qty
                                        let net_total_amount = grand_total_amount - grand_return_total_amount

                                        grand_detail.push(this.convertToCurrency(net_qty))
                                        grand_detail.push(this.convertToCurrency(net_total_amount))
                                    }

                                    if(this.isDiscount == true){
                                        grand_detail.push(this.convertToCurrency(grand_discount))
                                    }

                                    if(this.isVatBreakdown == true){
                                        grand_detail.push(this.convertToCurrency(grand_vatable))
                                        grand_detail.push(this.convertToCurrency(grand_vat))
                                        grand_detail.push(this.convertToCurrency(grand_non_vat))
                                        grand_detail.push(this.convertToCurrency(grand_add_on))
                                    }

                                    if(this.isPercent == true){
                                        grand_detail.push(this.convertToCurrency(100))
                                    }
                                    reportData.push(Object.assign({}, grand_detail));

                                } else {
                                    if(selectedGroup != 'category_id'){
                                        let current_grouper = ""
                                        let next_grouper = ""

                                        current_grouper = reportLine.grouper_id
                                        next_grouper = this.birSalesReports[i+1].grouper_id

                                        if(current_grouper != next_grouper){
                                            sub_detail = ['Sub Total :',
                                                this.convertToCurrency(total_qty),
                                                this.convertToCurrency(total_total_amount)
                                            ]

                                            if(this.isNetReturn == true){
                                                sub_detail.push(this.convertToCurrency(total_return_qty))
                                                sub_detail.push(this.convertToCurrency(total_return_total_amount))

                                                //net of returns
                                                let net_qty = total_qty - total_return_qty
                                                let net_total_amount = total_total_amount - total_return_total_amount

                                                sub_detail.push(this.convertToCurrency(net_qty))
                                                sub_detail.push(this.convertToCurrency(net_total_amount))
                                            }

                                            if(this.isDiscount == true){
                                                sub_detail.push(this.convertToCurrency(total_discount))
                                            }

                                            if(this.isVatBreakdown == true){
                                                sub_detail.push(this.convertToCurrency(total_vatable))
                                                sub_detail.push(this.convertToCurrency(total_vat))
                                                sub_detail.push(this.convertToCurrency(total_non_vat))
                                                sub_detail.push(this.convertToCurrency(total_add_on))
                                            }

                                            if(this.isPercent == true){
                                                if(total_percent == 0 && total_total_amount > 0 && sub_percent == 100){
                                                    sub_percent -= 0.01
                                                } else {
                                                    sub_percent -= total_percent
                                                }
                                                sub_detail.push(this.convertToCurrency(total_percent))
                                            }

                                            reportData.push(Object.assign({}, sub_detail))

                                            total_qty = 0
                                            total_total_amount = 0
                                            total_discount = 0
                                            total_percent = 0

                                            total_return_qty = 0
                                            total_return_total_amount = 0

                                            total_vatable = 0
                                            total_vat = 0
                                            total_non_vat = 0
                                            total_add_on = 0
                                        }
                                    }
                                }
                            }

                        }


                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        if(this.isSeparateSite == true){
                            reportData.push([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }

                        if(this.isPercent == true){
                            var legends = ['% Share = Amount / Grand Total * 100%']
                            reportData = reportUtils.csvxlsxTools.addLegend(reportData, legends)
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push(["Category Sales Report" + group_text, "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                        // this.JsonData = site_specific;
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },

            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;
                
            },

            async getSubBrandData() {
                if (this.inputBrand != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_id=" +
                        this.inputBrand,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
